<div class="fixed inset-0 flex items-center justify-center overflow-y-auto py-6">
    <div class="w-full max-w-md">
        <div class="flex items-center justify-center mb-8">
            <img src="assets/brand/ai-lens-logo.svg" alt="AI Lens" class="h-10 w-auto" />
        </div>

        <div class="card border border-base-300 shadow-sm">
            <div class="card-body">
                <h2 class="text-[18px] font-bold tracking-tight text-gray-900">Create your account</h2>
                <p class="text-[13px] text-gray-500">Sign up to access Clinical AI Studio.</p>

                <form (ngSubmit)="onSubmit()" class="mt-5 space-y-4" novalidate>
                    <label class="block">
                        <span
                            class="text-[11px] font-semibold tracking-wide uppercase text-gray-700">Full name</span>
                        <input type="text" name="fullName" [(ngModel)]="fullName" #nameRef="ngModel" required
                            autocomplete="name" placeholder="Jane Doe"
                            class="input input-bordered w-full mt-1.5 h-10 text-[13px]"
                            [class.input-error]="(nameRef.dirty || nameRef.touched || submitted()) && nameError" />
                        @if ((nameRef.dirty || nameRef.touched || submitted()) && nameError) {
                        <span class="mt-1 block text-[11px] text-error">{{ nameError }}</span>
                        }
                    </label>
                    <label class="block">
                        <span
                            class="text-[11px] font-semibold tracking-wide uppercase text-gray-700">Email</span>
                        <input type="email" name="email" [(ngModel)]="email" #emailRef="ngModel" required
                            autocomplete="username" placeholder="you@organization.com"
                            class="input input-bordered w-full mt-1.5 h-10 text-[13px]"
                            [class.input-error]="(emailRef.dirty || emailRef.touched || submitted()) && emailError" />
                        @if ((emailRef.dirty || emailRef.touched || submitted()) && emailError) {
                        <span class="mt-1 block text-[11px] text-error">{{ emailError }}</span>
                        }
                    </label>
                    <label class="block">
                        <span
                            class="text-[11px] font-semibold tracking-wide uppercase text-gray-700">Password</span>
                        <div class="relative mt-1.5">
                            <input [type]="showPassword() ? 'text' : 'password'" name="password"
                                [(ngModel)]="password" #passwordRef="ngModel" required autocomplete="new-password"
                                placeholder="Create a password"
                                class="input input-bordered w-full h-10 text-[13px] pr-10"
                                [class.input-error]="(passwordRef.dirty || passwordRef.touched || submitted()) && passwordError" />
                            <button type="button"
                                (click)="showPassword.set(!showPassword())"
                                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                                class="absolute inset-y-0 right-0 z-10 flex items-center px-3 text-gray-400 hover:text-gray-600">
                                <span class="pi" [ngClass]="showPassword() ? 'pi-eye-slash' : 'pi-eye'"></span>
                            </button>
                        </div>
                        @if ((passwordRef.dirty || passwordRef.touched || submitted()) && passwordError) {
                        <span class="mt-1 block text-[11px] text-error">{{ passwordError }}</span>
                        }
                    </label>
                    <label class="block">
                        <span
                            class="text-[11px] font-semibold tracking-wide uppercase text-gray-700">Confirm password</span>
                        <div class="relative mt-1.5">
                            <input [type]="showConfirmPassword() ? 'text' : 'password'" name="confirmPassword"
                                [(ngModel)]="confirmPassword" #confirmRef="ngModel" required autocomplete="new-password"
                                placeholder="Re-enter your password"
                                class="input input-bordered w-full h-10 text-[13px] pr-10"
                                [class.input-error]="(confirmRef.dirty || confirmRef.touched || submitted()) && confirmError" />
                            <button type="button"
                                (click)="showConfirmPassword.set(!showConfirmPassword())"
                                [attr.aria-label]="showConfirmPassword() ? 'Hide password' : 'Show password'"
                                class="absolute inset-y-0 right-0 z-10 flex items-center px-3 text-gray-400 hover:text-gray-600">
                                <span class="pi" [ngClass]="showConfirmPassword() ? 'pi-eye-slash' : 'pi-eye'"></span>
                            </button>
                        </div>
                        @if ((confirmRef.dirty || confirmRef.touched || submitted()) && confirmError) {
                        <span class="mt-1 block text-[11px] text-error">{{ confirmError }}</span>
                        }
                    </label>
                    <button type="submit" class="btn btn-primary w-full"
                        [disabled]="submitting()">
                        {{ submitting() ? 'Creating account…' : 'Sign up' }}
                    </button>
                </form>
                <p class="mt-4 text-[12px] text-gray-500 text-center">
                    Already have an account?
                    <a routerLink="/login"
                        class="font-semibold text-primary hover:underline underline-offset-2">
                        Sign in
                    </a>
                </p>
            </div>
        </div>

        <p class="mt-6 text-center text-[11px] text-gray-500 font-mono">
            AI Lens · Clinical Ai Studio
        </p>
    </div>
</div>